export default __webpack_public_path__ + "static/media/26.b62644d6.png";